/**
 * Stop control — only meaningful while a run is still non-terminal, and
 * only for a viewer who may stop it (`canStop`: the run's owner or an
 * admin; a project reader sees other users' runs but the backend refuses
 * their Stop). A terminal run (succeeded/failed/denied/stopped/expired)
 * cannot be stopped again, so this renders nothing for one, or for a
 * viewer without `canStop`, rather than a button that can only fail.
 */

import type { ReactElement } from 'react';
import { isTerminalRunStatus, type RunStatus } from '../types/agentRun.types';

interface StopRunControlProps {
  status: RunStatus;
  canStop: boolean;
  onStop: () => void;
  isStopping: boolean;
}

export function StopRunControl({
  status,
  canStop,
  onStop,
  isStopping,
}: StopRunControlProps): ReactElement | null {
  if (!canStop || isTerminalRunStatus(status)) return null;

  return (
    <button
      type="button"
      className="run-detail__stop-btn"
      disabled={isStopping}
      onClick={onStop}
    >
      {isStopping ? 'Stopping...' : 'Stop'}
    </button>
  );
}
